
import React, { useState, useEffect } from 'react'
import * as XLSX from 'xlsx'
import constants from '../../constants/constants'
import { CommaSeparator } from '../../functions'
const DownloadSCVFromPending = ({
    data
    , setDownloadSCVFromPending
}) => {

    

    let tempList = [[
        constants.FirstNameAndLastName,
        constants.Email,
        constants.PayableAmount,
        constants.GatewayName,
        constants.PersianIssueDate,
        constants.OfficialFactorType,
        constants.InvoiceNumberInFactor
    ]]
    //******************************************************************************* */
    useEffect(() => {
        setDownloadSCVFromPending(false)
        data.data.map((item, index) => {
            let typeInvoice = ""
            switch (item.OfficialFactorType) {
                case 1:
                    typeInvoice = constants.InvoiceAccepted;
                    break;
                case 2:
                    typeInvoice = constants.InvoiceRejected;
                    break;
                case 4:
                    typeInvoice = constants.InvoiceReserved;
                    break;
                case null:
                    typeInvoice = constants.InvoicePendingToAccept;
                    break;
                default:
                    typeInvoice = "";
                    break;
            }

            let arr = []
            arr.push(item?.FirstNameAndLastName ?? '---')
            arr.push(item?.Email ?? '---')
            arr.push(item?.OfficialFactorType===4?item?.TotalAmountReservedOrReturned ?? '---':item?.PayableAmount??'---')
            arr.push(item?.GatewayName ?? '---')
            arr.push(item?.PersianIssueDateFa ?? '---')
            arr.push(typeInvoice ?? '---')
            arr.push(item?.InvoiceNumberInFactor ?? '---')
            tempList.push(arr)
        })
    }, [])
    //******************************************************************************** */
    useEffect(() => {
        const worksheet = XLSX.utils.json_to_sheet(tempList);
        XLSX.utils.json_to_sheet(tempList);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Sheet1");
        XLSX.writeFile(workbook, "DataSheet.xlsx");
    }, [])
    //******************************************************************************** */
    return (<>
    </>)
}

export default DownloadSCVFromPending